import React from 'react'

import {
  StyleSheet,
  View,
} from 'react-native';
import PromoCodes from '../components/payments/PromoCodes';

interface Props {
}

const PromoCodesScreen: React.FC<Props> = ({ 
}) => {   
  return ( 
    <View style={styles.container}>
      <PromoCodes />
    </View>
  )
};

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    flex: 1,
    width: "100%"
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 20
  }
});

export default PromoCodesScreen